module.exports = __webpack_public_path__ + "static/media/WhatIf.15ad6410.png";